import React from 'react';
import { string, shape, func, oneOfType, number } from 'prop-types';
// import FilterRefContext from '../filtered-listing/utils/filter-ref-context';

export default function ContentTile({ item, handleOpenModal, handleMouseEvent, refType }) {
    const isContractor = refType.toLowerCase() === 'contractor';
    const isFED = ((window.location.host).indexOf('localhost:300') === 0) || ((window.location.host).indexOf('fph-portal.luminary.space') >= 0);
    const fileImageUrl = `${isFED ? 'https://uat-portal.fph.com.au' : ''}/Content/Images/pdficon.png`;

    return (
        <tr
            className={`c-content-tile${(item.DraftDocketNumber || isContractor) ? ' link-tile' : ''}`}
            onClick={() => (item.DraftDocketNumber || isContractor) && handleOpenModal(item.DraftDocketNumber, 'edocket', '', item.ClientType, item.DraftDocketLink)}
            onMouseEnter={handleMouseEvent}
            onMouseLeave={handleMouseEvent}
            onBlur={handleMouseEvent}
            onFocus={handleMouseEvent}
        >
            <td className="edocket">
                {item.eDocketNumber}
            </td>
            <td className="date">
                {item.DocketDate}
            </td>
            <td className="job">
                {item.JobID}
            </td>
            {!isContractor && (
                <td className="costcode">
                    {item.CostCode}
                </td>
            )}
            <td className="equipment">
                {item.EquipmentName}{item.SupplierEquipment_RegoNo ? ` [${item.SupplierEquipment_RegoNo}]` : ''}
            </td>
            <td className="material">
                {item.MaterialType}
            </td>
            {!isContractor && (
                <td className="foreman">
                    {item.SiteForemanName}
                </td>
            )}
            <td className="site">
                {item.SiteName}
            </td>
            <td className="status">
                <span className={`status-span ${item.StatusName.replace(/\s+/g, '-').toLowerCase()}`}>{item.StatusName}</span>
            </td>
            {!isContractor && (
                <td className="file-link">
                    {item.ClientFileUri && (
                        <a href={item.ClientFileUri} target="_blank" rel="noreferrer noopener" onClick={e => { e.stopPropagation(); }} title="PDF">
                            <img className="file-link-icon" src={fileImageUrl} alt="PDF" />
                        </a>
                    )}
                </td>
            )}
        </tr>
    );
}

ContentTile.propTypes = {
    item: shape({
        Docket_ID: oneOfType([string, number]),
        DocketDate: string.isRequired,
        JobID: oneOfType([string, number]).isRequired,
        SupplierTradingName: string,
        EquipmentName: string,
        MaterialType: string,
        SiteForemanName: string,
        SiteName: string,
        StatusName: string,
        DraftDocketNumber: oneOfType([string, number]).isRequired
    }).isRequired,
    handleOpenModal: func.isRequired,
    handleMouseEvent: func,
    refType: string
};

ContentTile.defaultProps = {
    handleMouseEvent: () => {},
    refType: 'client'
};
